import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
    selector: '[app-library-window]',
    templateUrl: './library-window.component.html',
    styleUrl: './library-window.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LibraryWindowComponent {
  public height = input<number>();

  public leftWindowPositions = computed(() => this.generateWindows(this.height(), true));
  public rightWindowPositions = computed(() => this.generateWindows(this.height()));

  private generateWindows(height: number, isLeft?: boolean) {
    const rows = Math.ceil(height / 40);
    const spacing = 25; // Distance between each row
    return Array.from({ length: rows }, (_, i) => ({ x : 0, y: i * spacing, isLit: Math.random() > 0.5 }));
  }

  public trackByIndex = (index: number) => index;
}
